var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Focus_bucket",
    "data-name": "Focus bucket",
    transform: "translate(-1010 -240)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5554",
    "data-name": "Rectangle 5554",
    width: 17,
    height: 17,
    transform: "translate(1010 240)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34364",
    "data-name": "Path 34364",
    d: "M21.772,20.439a2.9,2.9,0,0,0,.345-.02v4.439a1.029,1.029,0,0,1-1.036,1.02H10.036A1.029,1.029,0,0,1,9,24.858v-6.8a1.029,1.029,0,0,1,1.036-1.02h8.651a2.766,2.766,0,0,0-.021.34,3.019,3.019,0,0,0,.68,1.909L16.291,22.3a1.049,1.049,0,0,1-1.465,0l-3.856-3.8a.35.35,0,0,0-.488,0,.337.337,0,0,0,0,.481l3.856,3.8a1.748,1.748,0,0,0,2.441,0l3.055-3.008A3.134,3.134,0,0,0,21.772,20.439Zm0-5.439a2.38,2.38,0,1,0,2.416,2.38A2.4,2.4,0,0,0,21.772,15Z",
    transform: "translate(1001.737 227.948)",
    fill: "#f60"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusBucket);
export default __webpack_public_path__ + "static/media/focusBucket.4420a0081944224c86a2b2ef04fd5183.svg";
export { ForwardRef as ReactComponent };